






























































































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {ReceiptPaymentType} from "@/enums/type";
import moment from "moment";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import {DebtCustomer} from "@/interfaces/entity";
import {ReceiptExpensePickingListPayStatus} from "@/enums/status";
import {ManageFeeStore} from "@/modules/managefeecustomer/store";

@Component({
    name: "ManageFeeCustomerPayedPrint",
})
export default class extends mixins(CommonMixin) {
    @Prop({ type: Boolean, default: false }) readonly isPrint!: boolean;
    @Prop({ required: true }) readonly id!: any;

    ReceiptPaymentType = ReceiptPaymentType;
    ReceiptExpensePickingListPayStatus = ReceiptExpensePickingListPayStatus;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;


    get pickingList(): ReceiptExpensePickingList {
        return ManageFeeStore.payedData[this.id];
    }

    get debts(): Array<DebtCustomer> {
        return ManageFeeStore.debtsOfPayed;
    }

    get totalMoney() {
        return this.debts.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.money || 0);
        }, 0);
    }

    getVat(totalFee: any) {
        if (isNaN(totalFee)) return 0;
        return Math.ceil((totalFee - totalFee/1.1));
    }
}
